<template>
    <div class="container">
        <vue-headful
                title="News - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">All News</h3>
                            </div>
                            <div class="">
                                <router-link :to="{name: 'website-create-news'}" class="btn my-4 btn-primary">
                                    ADD NEWS
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">News Title</th>
                                <th scope="col">News Subtitle</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="news in newsAdd" :key="news.id">
                                <td>
                                    <button @click="deleteNews(news.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Idea"></button>
                                    <router-link :to="{name: 'website-update-news', params: { news_id: news.id }}" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Idea"></router-link>
                                </td>
                                <td scope="row">
                                    <strong>{{news.news_title}}</strong>
                                </td>
                                <td>
                                    {{news.news_subtitle}}
                                </td>
                                <!--<td>-->
                                    <!--{{news.news_short_description}}-->
                                <!--</td>-->
                                <!--<td>-->
                                    <!--{{news.news_content}}-->
                                <!--</td>-->
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      newsAdd: {}
    };
  },
  methods: {
    goNew: function() {
      window.location.href = "/dashboard/website/create-new";
    },
    editNews: function(news_id) {
      window.location.href = "/dashboard/website/update-new/" + news_id;
    },
    get_News() {
      axios({
        url: "admin/news?access_token=" + localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.newsAdd = result.data.news.data;
            console.log(result);
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteNews(id) {
      axios({
        method: "delete",
        url: "admin/news/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("News Deleted Successfully", "", "success");
            console.log(result);
            this.get_News();
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_News();
  }
};
</script>
<style>
</style>
